import { z } from 'zod'

export const insuranceTypeEnum = [
  'commercial',
  'medicare',
  'medicaid',
  'tricare',
  'workers_comp',
  'other',
] as const

export const insuranceSchema = z.object({
  id: z.number().optional(),
  practice: z.number(),
  carrier: z.string().max(200),
  address: z.string().max(200).optional().nullable(),
  suite: z.string().max(35).optional().nullable(),
  city: z.string().max(50).optional().nullable(),
  state: z.string().max(2).optional().nullable(),
  zip: z.string().max(10).optional().nullable(),
  phone: z.string().max(20).optional().nullable(),
  extension: z.string().max(6).optional().nullable(),
  created_date: z.string().datetime().optional().nullable(),
  deleted_date: z.string().datetime().optional().nullable(),
  patients: z.array(z.number()).optional().nullable(),
  plans: z.array(z.number()).optional().nullable(),
  payer_id: z.string().max(200).optional().nullable(),
  external_vendor_id: z.string().max(200).optional().nullable(),
  is_credentialed: z.boolean().optional().nullable(),
  aliases: z.string().max(300).optional().nullable(),
  insurance_type: z.enum(insuranceTypeEnum).optional().nullable(),
})

export type Insurance = z.infer<typeof insuranceSchema>
